module.exports = __webpack_public_path__ + "img/skipPoint.7021fc37.png";